var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100vw","height":"100vh"},attrs:{"src":_vm.thankYouPageUrl,"title":_vm.thankYouPageTitle,"frameborder":"0","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }